/** Password rule shared by Add Admin User and Reset password (functional spec, API Contract Reference — Admin users). */
export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_TOO_SHORT = `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
export const PASSWORD_REQUIRED = 'Password is required.';
/**
 * The confirm field gets its own wording. Repeating "Password is required." under two
 * adjacent fields makes the reader stop to work out whether they misread one of them —
 * two identical messages look like a rendering mistake, not like two separate problems.
 */
export const PASSWORD_CONFIRMATION_REQUIRED = 'Type the password again to confirm it.';
export const PASSWORDS_DO_NOT_MATCH = 'The two passwords do not match.';

export function validatePassword(value: string): string | undefined {
  if (value.length === 0) return PASSWORD_REQUIRED;
  if (value.length < PASSWORD_MIN_LENGTH) return PASSWORD_TOO_SHORT;
  return undefined;
}

export function validatePasswordConfirmation(
  password: string,
  confirmation: string,
): string | undefined {
  if (confirmation.length === 0) return PASSWORD_CONFIRMATION_REQUIRED;
  if (password !== confirmation) return PASSWORDS_DO_NOT_MATCH;
  return undefined;
}
